// src/services/api/cart.ts
import { httpClient } from '@/services/http/client';
import { ApiResponse } from '@/services/types/api';
import { ApiCartResponse, Cart, CartItem } from '@/services/types/domain';

class CartApi {
    private readonly basePath = '/cart';

    /**
     * Obtener carrito actual
     */
    async getCart(): Promise<ApiCartResponse> {
        const response = await httpClient.get<ApiResponse<any>>(this.basePath);
        return response.data;
    }

    /**
     * Obtener contador de items en el carrito
     */
    async getCartCount(): Promise<number> {
        const response = await httpClient.get<ApiResponse<{ count: number }>>(
            `${this.basePath}/count`
        );
        //console.log("cc", response.data.data.count);
        return response.data.data.count;
    }

    /**
     * Agregar item al carrito
     */
    async addItem(data: {
        product_id: number;
        variant_id?: number;
        quantity: number;
    }): Promise<CartItem> {
        const response = await httpClient.post<ApiResponse<CartItem>>(
            `${this.basePath}/items`,
            data
        );
        return response.data.data;
    }

    /**
     * Actualizar cantidad de item en el carrito
     */
    async updateItem(itemId: number, quantity: number): Promise<CartItem> {
        const response = await httpClient.put<ApiResponse<CartItem>>(
            `${this.basePath}/items/${itemId}`,
            { quantity }
        );
        return response.data.data;
    }

    /**
     * Eliminar item del carrito
     */
    async removeItem(itemId: number): Promise<void> {
        await httpClient.delete(`${this.basePath}/items/${itemId}`);
    }

    /**
     * Limpiar todo el carrito
     */
    async clearCart(): Promise<void> {
        await httpClient.delete(this.basePath);
    }

    /**
     * Aplicar cupón de descuento
     */
    async applyCoupon(couponCode: string): Promise<Cart> {
        const response = await httpClient.post<ApiResponse<Cart>>(
            `${this.basePath}/coupon`,
            { coupon_code: couponCode }
        );
        return response.data.data;
    }

    /**
     * Remover cupón de descuento
     */
    async removeCoupon(): Promise<Cart> {
        const response = await httpClient.delete<ApiResponse<Cart>>(
            `${this.basePath}/coupon`
        );
        return response.data.data;
    }

    /**
     * Verificar stock de un item antes de agregar
     */
    async checkStock(productId: number, variantId?: number, quantity: number = 1): Promise<{
        available: boolean;
        stock_quantity: number;
        max_quantity: number;
    }> {
        const params: any = { quantity };
        if (variantId) params.variant_id = variantId;

        const response = await httpClient.get<ApiResponse<{
            available: boolean;
            stock_quantity: number;
            max_quantity: number;
        }>>(
            `products/${productId}/stock`,
            { params }
        );
        return response.data.data;
    }

    /**
     * Debug del carrito (solo desarrollo)
     */
    async debugCart(): Promise<any> {
        const response = await httpClient.get<ApiResponse<any>>(
            `${this.basePath}/debug`
        );
        return response.data.data;
    }
}

// Instancia singleton
export const cartApi = new CartApi();
export default cartApi;

